export default "__VITE_ASSET__D4CP8Rxj__"